import { requiredErrorMessage } from "../../../utils/helpers";

export const validateInput = (event: any) => {
  // ******CAUCTION********* Please ensure to double-check before making changes, as these alterations will replace the entire input and number fields.

  const { validity } = event.target;
  if (!validity.valid) {
    if (!validity.badInput && validity.valueMissing) {
      event.target.setCustomValidity(requiredErrorMessage(event));
    }

    // if (validity.badInput) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.customError) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.patternMismatch) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.rangeOverflow) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.rangeUnderflow) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.stepMismatch) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.tooLong) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.tooShort) {
    //   event.target.setCustomValidity("Set the message to show");
    // }

    // if (validity.typeMismatch) {
    //   event.target.setCustomValidity("Set the message to show");
    // }
  }
  return { valid: validity.valid, validErrorMessage: event.target?.validationMessage || "" };
};
